import moment from "moment"

export const secondsToTime = (inputSeconds) => {
  let duration = moment.duration(inputSeconds, "seconds")
  let hours = Math.floor(duration.asHours())
  let minutes = Math.floor(duration.asMinutes()) - hours * 60
  let seconds =
    Math.floor(duration.asSeconds()) - hours * 60 * 60 - minutes * 60

  return (
    (hours ? hours + ":" : "") +
    (minutes === 0 ? "00" : minutes > 9 ? minutes : "0" + minutes) +
    ":" +
    (seconds > 9 ? seconds : "0" + seconds)
  )
}

export const millisecondsToTime = (inputMilliseconds) => {
  let duration = moment.duration(inputMilliseconds, "milliseconds")
  let hours = Math.floor(duration.asHours())
  let minutes = Math.floor(duration.asMinutes()) - hours * 60
  let seconds =
    Math.floor(duration.asSeconds()) - hours * 60 * 60 - minutes * 60
  let milliseconds =
    Math.floor(duration.asMilliseconds()) -
    hours * 60 * 60 * 1000 -
    minutes * 60 * 1000 -
    seconds * 1000

  return (
    (hours ? hours + ":" : "") +
    (minutes === 0 ? "00" : minutes > 9 ? minutes : "0" + minutes) +
    ":" +
    (seconds > 9 ? seconds : "0" + seconds) +
    "." +
    (milliseconds > 99
      ? milliseconds
      : milliseconds > 9
      ? "0" + milliseconds
      : "00" + milliseconds)
  )
}

export const shuffle = (answers, order) => {
  let newAnswers = []

  answers.forEach(
    (answer, index) => (newAnswers[order.indexOf(index)] = answer)
  )

  return newAnswers
}

export const sanitizeYaml = (text) =>
  text
    ? typeof text === "object"
      ? Object.keys(text)[0] + ":"
      : text.toString()
    : ""
